<template>
  <div class="row">
    <div class="col-xs-12">
      <div class="header-action">
        <button type="button" class="btn btn-primary" @click="$router.back()">
          <font-awesome-icon :icon="'arrow-left'" />
          Voltar
        </button>
        <button type="button" class="btn btn-default">
          <font-awesome-icon :icon="'check'" />
          Homologar
        </button>
      </div>
      <h1 class="page-header">
        Editar Compromisso
        <span class="status" :class="statusClass(model.status)">
          {{ model.status }}
        </span>
      </h1>
      <div class="row">
        <div class="col-xs-12">

          <div class="col-xs-12 col-sm-4">
            <div class="form-group">
              <label class="control-label custom-font">Período</label>
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon :icon="'calendar-alt'"></font-awesome-icon>
                  </span>
                  <input type="text" v-model="model.periodo" class="form-control" disabled />
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-4">
            <div class="form-group">
              <label class="control-label custom-font">Funcionário Responsável</label>
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon :icon="'user'"></font-awesome-icon>
                  </span>
                  <input type="text" v-model="model.responsavel_sshd" class="form-control" disabled />
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-4">
            <div :class="['form-group', { 'has-error': errors.has('unidade') }]">
              <label class="control-label custom-font">Unidade</label>
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon :icon="'sitemap'"></font-awesome-icon>
                  </span>
                  <select ref="unidade" class="form-control select-selected" name="unidade" v-model="model.unidade_executora"
                    v-validate="'required'">
                    <option disabled value="">Selecione a unidade</option>

                    <optgroup label="Secretarias">
                      <option v-for="s in listas.secretarias" :key="s.sigla" :value="s.sigla" :title="s.nome">
                        {{ s.sigla }}
                      </option>
                    </optgroup>

                    <optgroup label="Autarquias">
                      <option v-for="a in listas.autarquias" :key="a.sigla" :value="a.sigla" :title="a.nome">
                        {{ a.sigla }}
                      </option>
                    </optgroup>

                  </select>
                </div>
                <small v-if="errors.has('unidade')" data-bv-validator="notempty" data-bv-validator-for="unidade"
                  class="help-block" style="">Preenchimento obrigatório!
                </small>
              </div>
            </div>
          </div>

          <div class="col-xs-12">
            <div :class="['form-group', { 'has-error': errors.has('titulo') }]">
              <label class="control-label custom-font">Título</label>
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon :icon="'tags'"></font-awesome-icon>
                  </span>
                  <input type="text" ref="titulo" name="titulo" v-model="model.titulo" placeholder="Título" disabled
                    maxlength="255" class="form-control" v-validate="'required'" />
                  <div class="input-group-addon custom-input-group-addon-count" v-text="255 - model.titulo.length">
                  </div>
                </div>
                <small v-if="errors.has('titulo')" data-bv-validator="notempty" data-bv-validator-for="titulo"
                  class="help-block" style="">Preenchimento obrigatório!
                </small>
              </div>
            </div>
          </div>

          <div class="col-xs-12">
            <div :class="['form-group', { 'has-error': errors.has('descricao') }]">
              <label class="control-label custom-font">Descrição</label>
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon :icon="'comment'"></font-awesome-icon>
                  </span>
                  <textarea ref="descricao" v-model="model.descricao" name="descricao" disabled
                    placeholder="Descreva o compromisso..." maxlength="1000" class="form-control" v-validate="'required'"
                    rows="8"></textarea>
                  <div class="input-group-addon custom-input-group-addon-count" v-text="1000 - model.descricao.length">
                  </div>
                </div>
                <small v-if="errors.has('descricao')" data-bv-validator="notempty" data-bv-validator-for="descricao"
                  class="help-block" style="">Preenchimento obrigatório!
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
h1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 15px;
  padding-left: 15px;
}

.status {
  font-size: 0.25em;
  color: #fff;
  border: 2px solid;
  border-radius: 6px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  padding: 4px 10px;
}

.status-n-iniciado {
  background-color: #999;
}

.status-andamento {
  background-color: #f0ad4e;
}

.status-concluido {
  background-color: #5cb85c;
}

.status-cancelado {
  background-color: #d9534f;
}

.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-meta {
  color: #00615c;
}

.select-selected {
  color: #00615c;
}

.custom-input-group-addon-count {
  color: #00615c;
}

.fa-sitemap {
  color: #00615c;
}

.fa-user {
  color: #00615c;
}

.fa-check-double-white {
  color: #fff;
}

.fa-tags {
  color: #00615c;
}

.fa-comment {
  color: #00615c;
}

.fa-save-white {
  color: #fff;
}

.fa-long-arrow-alt-left-white {
  color: #fff;
}

.fa-calendar-alt {
  color: #00615c;
}

.header-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-right: 15px;
  padding-left: 15px;
}
</style>

<script>
import { request } from '@/request'

export default {
  name: 'plano-governo-edit',
  inject: ["showConfirm"],
  props: ['id'],
  data() {
    return {
      listas: {
        secretarias: [],
        autarquias: [],
      },
      model: {
        titulo: '',
        descricao: '',
        periodo: '',
        unidade_executora: '',
        responsavel_sshd: '',
        data_conclusao: ''
      }
    }
  },
  created() {
    this.loadCompromisso()
    this.loadUnidades()
  },
  mounted() {
    this.$refs.periodo.focus()
  },
  computed: {
    isUpdate() {
      return this.model.hasOwnProperty('codigo')
    },
    isAdd() {
      return !this.isUpdate
    },
    urlToSave() {
      return this.isUpdate ? 'planogoverno/update' : 'planogoverno/add'
    },
    selecionaMetas() {
      return this.listas.metas
        .filter(i => {
          return i.selected
        })
        .map(i => {
          return i.codigo
        })
    }
  },
  methods: {
    async loadCompromisso() {
      const { data } = await request.get(`planogoverno/compromisso/${this.id}`)
      this.model = data
    },
    async save() {
      const { unidade } = this.model
      const response = await request.put('planogoverno/compromisso', { unidade })

      if (response.status != 201) return this.$toastr.e('Houve uma falha ao tentar salvar o compromisso.')

      this.$toastr.s('O compromisso foi atualizado com sucesso.')
      this.$router.push({ name: 'admin_planogoverno' })
    },
    async homologar() {
      const { status } = await request.put('planogoverno/compromisso', { data_conclusao: new Date() })

      if (status != 201) return this.$toastr.e('Houve uma falha ao tentar homologar o compromisso.')

      this.$toastr.s('O compromisso foi homologado com sucesso.')
      this.$router.push({ name: 'admin_planogoverno' })
    },
    async loadUnidades() {
      const { data: { data: secretarias } } = await request.get('listar-secretarias')
      const { data: { data: autarquias } } = await request.get('listar-autarquias')

      this.listas.secretarias = secretarias
      this.listas.autarquias = autarquias
    },
    statusClass(status) {
      switch (status) {
        case 'Não Iniciado':
          return 'status-n-iniciado'
        case 'Em andamento':
          return 'status-andamento'
        case 'Concluído':
          return 'status-concluido'
        case 'Cancelado':
          return 'status-cancelado'
        default:
          return 'status-n-iniciado'
      }
    }
  }
}
</script>

<style>
.list-group img {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/admin/plano-governo/Edit.vue